import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ChatChannelType, InitialModality } from '@nimbus-library/features/shared/models/participant-info/i-combined-conversation.response';
import { AgentAssistantApiClient } from './api/agent-assistant.api-client';

@Injectable({ providedIn: 'root' })
export class AgentAssistantAcwService {
  public constructor(private readonly agentAssistantApiClient: AgentAssistantApiClient) {}

  public extendAcw(
    callId: string,
    callSessionId: string,
    userSessionId: string,
    initialModality: InitialModality,
    channel?: ChatChannelType,
    tenantId?: string,
    userId?: string,
  ): Observable<void> {
    return this.agentAssistantApiClient.extendAcw(callId, callSessionId, userSessionId, initialModality, channel, tenantId, userId);
  }

  public stopAcw(
    callId: string,
    callSessionId: string,
    userSessionId: string,
    initialModality: InitialModality,
    channel?: ChatChannelType,
    tenantId?: string,
    userId?: string,
  ): Observable<void> {
    return this.agentAssistantApiClient.stopAcw(callId, callSessionId, userSessionId, initialModality, channel, tenantId, userId);
  }
}
